import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const DATETIME_STRING_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DATETIME_FORMAT = 'dddd, MMMM D YYYY HH:mm a';

export function nowString() {
    return dayjs().format(DATETIME_STRING_FORMAT);
}

export function dayjsToString(dayjs) {
    return dayjs.format(DATETIME_STRING_FORMAT);
}

export function friendlyDateTime(start) {
    return dayjs(start).format(DATETIME_FORMAT);
}
